module.exports = __webpack_public_path__ + "img/Management.528a1d78.svg";